export default __webpack_public_path__ + "static/media/whatsapp-logo-negro.0104ad1e.svg";